<template>
  <div v-show="selectedFile && selectedFile.key">
    <ol class="breadcrumb text-overflow allow-user-select" ref="crumbs">
      <li v-for="(name,index) in crumbs" :key="`crumb-${index}`">
        {{name}}
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  props: {
    selectedFile: Object,
  },
  data() {
    return {
      crumbs: [],
    };
  },
  watch: {
    selectedFile(val) {
      this.initData(val);
    },
  },
  methods: {
    initData(file) {
      this.crumbs = [];
      if (file && file.key) {
        const prefix = (file.key || '').replace(/^\//, '').replace(/\/$/, '');
        if (prefix) {
          this.crumbs = prefix.split('/');
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.breadcrumb {
  font-size: 12px;
  li {
    font-size: 12px;
    font-weight: 400;
    color: #677180;
    vertical-align: middle;
    display: inline-block;
  }
}
</style>
